import React from "react";
import { useState } from "react";
import { Button, ButtonGroup, Card, CardBody, CardHeader, Col, FormGroup, Input, ListGroup, ListGroupItem, Row } from "reactstrap";
import symtoms_icon from 'assets/images/symtoms-icon.png'
import allergies_icon from 'assets/images/allergies-icon.png'
import surgeries_icon from 'assets/images/surgeries-icon.png'
import check_icon from 'assets/svgIcon/check_icon.svg'
import ReactQuill from "react-quill";
const MHScreenThree = (props)=>{
    const [stepFormCur, setStepFormCur] = useState(0);
    return (
        <><CardBody className={`nex-form-step ${stepFormCur == 0 ? 'active' : ''}`}>
        <br/>
        <div className="nex-form-field-container">
        <div className="nex-form-group">
            <div className="nex-form-group-c">
            
    

                        <label htmlFor="" className="nex-big-label mb-3">Any past hospitalizations ?</label>
            <FormGroup>
                        <ReactQuill
                id="sq_health_issue"
                placeholder="Enter Your past hospitalizations"
                value={''}
                bounds={".app"}
              />
                        </FormGroup>

                        <label htmlFor="" className="nex-big-label mb-3">Please brief your Current Medications ?</label>
            <FormGroup>
                        <ReactQuill
                id="sq_health_issue"
                placeholder="Enter Your Current Medications"
                value={''}
                bounds={".app"}
              />
                        </FormGroup>
            </div>
        </div>
        </div>
        <div className="nex-form-group-c">
        <div className="nex-form-action">
            <Button
                color="primary"
                className="nexogic_primary_button"
                onClick={(e)=>props.goto(e, 8)}
            >
                Next
            </Button>
        </div>
        </div>


    </CardBody></>
    )
}
export default MHScreenThree;